import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Logo } from "@/components/Logo";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success(data.message);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-5 py-16">
      <div className="flex justify-center mb-8"><Logo /></div>
      <div className="border border-slate-200 rounded-2xl bg-white p-8">
        <h1 className="font-display text-2xl font-bold text-slate-900">Forgot password</h1>
        <p className="text-sm text-slate-500 mt-1">We&apos;ll email you a link to reset it.</p>
        {sent ? (
          <div className="mt-6 p-4 rounded-xl bg-emerald-50 border border-emerald-200 text-sm text-emerald-800">
            If that email is registered, a reset link has been sent. Please check your inbox.
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" className="mt-1.5" />
            </div>
            <Button type="submit" disabled={busy} data-testid="forgot-submit-btn" className="w-full pill-btn bg-[#1E3A8A] hover:bg-[#1E40AF] text-white h-11">
              {busy ? "Sending…" : "Send reset link"}
            </Button>
          </form>
        )}
        <p className="mt-6 text-sm text-slate-600 text-center">
          <Link to="/login" className="text-[#1E3A8A] font-semibold hover:underline">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
